import React, { useState, useEffect, useRef } from "react";
import bg from "assests/About/ISO/bg.jpg";
import Container from "Components/Container/Container";
import SocialMedia from "Pages/Home/Hero/SocialMedia/SocialMedia";
const Hero = ({ data }) => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1, // Adjust the threshold as needed
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setVisible(true);
        } else {
          setVisible(false);
        }
      });
    }, options);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return (
    <section
      ref={sectionRef}
      className="scroll-section-special background"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <Container className="py-44 lg:h-[100vh] relative">
        <div className="min-h-full flex flex-col items-center justify-center">
          <h1 className="bebas text-6xl md:text-7xl lg:text-8xl uppercase text-white text-font ">
            {data?.title}
          </h1>

          <p
            className="text-white text-center lg:w-1/2 mt-4"
            dangerouslySetInnerHTML={{ __html: data?.text }}
          />

          <img
            className={`w-[18rem] lg:w-[24rem] m-10`}
            src={data?.certificate_logo}
            alt=""
          />
        </div>
        <SocialMedia />
      </Container>
    </section>
  );
};

export default Hero;
